(function () {
    'use strict';

    angular.module('notes')
        .filter('breakLines', breakLines);

    function breakLines() {
        return function (input) {
            return input.replace(/(?:\r\n|\r|\n)/g, '<br />');
        };
    }
})();
